/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Engineering_Technology32Inputs */

const en__field_enum_csjensblank_engineering_technology32 = /** @type {(inputs: _Field_Enum_Csjensblank_Engineering_Technology32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engineering & Technology`)
};

const de__field_enum_csjensblank_engineering_technology32 = /** @type {(inputs: _Field_Enum_Csjensblank_Engineering_Technology32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingenieurwesen & Technologie`)
};

/**
* | output |
* | --- |
* | "Engineering & Technology" |
*
* @param {_Field_Enum_Csjensblank_Engineering_Technology32Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_engineering_technology32 = /** @type {((inputs?: _Field_Enum_Csjensblank_Engineering_Technology32Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Engineering_Technology32Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_engineering_technology32(inputs)
	return de__field_enum_csjensblank_engineering_technology32(inputs)
});
export { _field_enum_csjensblank_engineering_technology32 as "_field_enum_CSJENSBLANK_ENGINEERING_TECHNOLOGY" }